import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.91666 7.91536H17.0833M6.24999 3.7487V2.08203M13.75 3.7487V2.08203M3.74999 17.082H16.25C16.7102 17.082 17.0833 16.7089 17.0833 16.2487V4.58203C17.0833 4.12179 16.7102 3.7487 16.25 3.7487H3.74999C3.28975 3.7487 2.91666 4.12179 2.91666 4.58203V16.2487C2.91666 16.7089 3.28975 17.082 3.74999 17.082Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }